export default function useGridColumnWidths(
	cssWidths: string[],
	colCount: number,
) {
	let value = [];
	if (colCount === cssWidths.length) {
		value = cssWidths;
	} else if (colCount < cssWidths.length) {
		value = cssWidths.slice(0, colCount);
	} else {
		const _widths = cssWidths.slice();
		const last = _widths.pop();
		value = Array.from({ length: colCount }, (_, i) => {
			if (i === colCount - 1) {
				return last;
			}
			if (i < _widths.length) {
				return _widths[i];
			}
			return _widths[_widths.length - 1];
		});
	}
	return value.join(" ");
}
